import IdCardBiometryController from "./idCardBiometry.controller";
import "./biometry.scss";
import IdentificationContent from "./identificationModal/IdentificationContent";

const IdCardBiometry = () => {
    const { leadId } = IdCardBiometryController();

    return (
        <div className="idcard-biometry-container">
            <IdentificationContent leadId={leadId} />
        </div>
    );
}

export default IdCardBiometry;